export const CONTRIBUTOR_KEY = "anjabom.contributor-key.v1";
export function contributorKey(): string {
	const current = localStorage.getItem(CONTRIBUTOR_KEY);
	if (current && /^[a-f0-9-]{72}$/.test(current)) return current;
	const key = crypto.randomUUID() + crypto.randomUUID();
	localStorage.setItem(CONTRIBUTOR_KEY, key);
	if (localStorage.getItem(CONTRIBUTOR_KEY) !== key)
		throw new Error(
			"기기 열쇠를 저장하지 못했어요. 저장 공간을 확인해 주세요.",
		);
	return key;
}
